<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Seat Number Import</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row dense class="px-4 pt-4 mb-4">
                <v-col sm="6" md="4" cols="12">
                    <v-autocomplete v-model="ay" :items="ay_list" label="Select Academic Year" item-text="name"
                        item-value="id" clearable dense outlined rounded></v-autocomplete>
                </v-col>
                <v-col sm="6" md="4" cols="12">
                    <v-autocomplete v-model="standard" :items="standard_list" item-text="name" item-value="id"
                        label="Select Standard" clearable dense outlined rounded
                        @change="getDivsions()"></v-autocomplete>
                </v-col>
                <v-col sm="6" md="4" cols="12">
                    <v-autocomplete v-model="div" :items="div_list" label="Select Division" clearable dense outlined
                        item-text="name" item-value="id" rounded></v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                    <v-btn color="primary" @click="fetchStudents()" small>
                        Fetch
                    </v-btn>
                </v-col>
                <v-col cols="12" v-if="learner_list.length>0" class="d-flex justify-end">
                    <v-btn color="success" @click="openFileSelector()" small>
                        Import Seat No
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="learner_list.length > 0" class="d-flex justify-center align-center">
    
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="commonSeatNo"
                        label="Common Prefix Seat No"
                        outlined
                        dense
                        placeholder="Enter Common Prefix seat no"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" md="2" class="d-flex align-center">
                    <v-btn color="success" @click="applyToAll()" small class="mb-6">
                        Apply
                    </v-btn>
                </v-col>

            </v-row>
            <v-data-table :headers="headers" :items="learner_list" class="elevation-1 mytable" dense v-if="learner_list.length>0">
                <template v-slot:item.seatno="{ item }">
                    <v-text-field v-model="item.seatno" dense outlined hide-details
                        placeholder="Enter Seat No"></v-text-field>
                </template>

                <template v-slot:item.action="{ item }">
                    <v-btn small color="primary" @click="saveSeatNo(item)">
                        Save
                    </v-btn>
                </template>
            </v-data-table>

            <v-row class="pa-4" v-if="learner_list.length>0">
                <v-col cols="12" class="d-flex justify-center">
                    <v-btn color="primary" @click="saveAllSeatNo()">
                        Save All
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="import_dialog" max-width="500px">
        <v-card>
            <v-card-title>
            <span class="headline mb-5">Import Caste</span>
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="generateExcel" class="mb-5">
            Download Excel Template
            </v-btn>
            </v-card-title>

            <v-card-text>
            <v-file-input
                v-model="file"
                label="Select Seat No CSV File"
                prepend-icon="mdi-file"
                outlined
                rounded
                dense
                show-size
            ></v-file-input>
            </v-card-text>

            <v-card-actions class="justify-center">
            <v-btn color="blue darken-1" text @click="import_dialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" @click="importSeatNo" :disabled="!file">Submit</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        file:null,
        import_dialog:false,
        search: "",
        prn: "",
        ay: "",
        standard: "",
        div: "",
        commonSeatNo: "",
        previousValue: "",
        dialog: false,
        headers: [
            {
                text: "PRN No.",
                align: "left",
                sortable: false,
                value: "prn",
            },
            {
                text: "Name",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "Seat No.",
                align: "center",
                sortable: false,
                value: "seatno",
            },
            {
                text: " Actions",
                value: "action",
                sortable: false
            },
        ],
        ay_lisy: [],
        standard_list: [],
        div_list: [],
        learner_list: [],
        editedIndex: -1,
        fieldNames: ["PRN No.", "Seat No."]
    }),

    watch: {
        dialog(val) {
            val || this.close();
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {

        openFileSelector() {
            this.import_dialog = true;
        },

        onLoad() {
            this.overlay = true;
            this.name = "";
            axios
                .post("/examination/getData")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.ay_list = res.data.ay_list;
                        this.standard_list = res.data.standard_list
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getDivsions() {
            const data = {
                ay: this.ay,
                standard: this.standard
            }
            axios
                .post("/examination/getDivisions", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.div_list = res.data.div_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        fetchStudents() {
            const data = {
                ay: this.ay,
                standard: this.standard,
                div: this.div
            }
            axios
                .post("/examination/fetchStudents", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.learner_list = res.data.learner_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        saveSeatNo(item) {
            const data = {
                id: item.id,
                prn: item.prn,
                seatno: item.seatno
            }
            axios
                .post("/examination/saveSeatNo", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.overlay = false;
                        this.fetchStudents()
                        this.showSnackbar("#4caf50", res.data.msg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        importSeatNo() {
            if (!this.file) {
                this.showSnackbar("#b71c1c", "Please select a file!");
                return;
            }

            const formData = new FormData();
            formData.append("file", this.file);
            formData.append("ay", this.ay);
            formData.append("standard", this.standard);
            formData.append("div", this.div);
            this.overlay = true;

            axios.post("/examination/importSeatNo", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "EPS-token": localStorage.getItem("EPS-token"),
                    "EPS-uid": localStorage.getItem("EPS-uid"),
                    "router-path": this.$route.path
                }
                })
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.overlay = false;
                        this.fetchStudents()
                         this.showSnackbar("#4caf50", res.data.msg);
                         this.close()
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        saveAllSeatNo() {
           const data = this.learner_list.map(item => ({
                id: item.id,
                prn: item.prn,
                seatno: item.seatno
            }));

            this.overlay = true;
            axios
                .post("/examination/saveAllSeatNo", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.overlay = false;
                        this.fetchStudents()
                        this.showSnackbar("#4caf50", res.data.msg);
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        generateExcel() {
                try {
                const dataForSheet = [this.fieldNames];
                const worksheet = XLSX.utils.aoa_to_sheet(dataForSheet);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Bulk Import Seat No");
                const wscols = this.fieldNames.map(() => ({ wch: 20 }));
                worksheet['!cols'] = wscols;
                XLSX.writeFile(workbook, "Seat_No_Import_Template.xlsx");
                
                } catch (error) {
                console.error("Error generating Excel:", error);
                alert("Failed to generate Excel file.");
                }
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        applyToAll() {
            this.learner_list.forEach(item => {
                if (!item.seatno || item.seatno === this.previousValue) {
                    item.seatno = this.commonSeatNo;
                }
            });

            this.previousValue = this.commonSeatNo;
        },

        close() {
            this.dialog = false;
            this.import_dialog = false;
            setTimeout(() => {
                this.editedIndex = -1;
            }, 300);
        },

    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>